var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"relative"},[_c('div',{staticClass:"vx-navbar-wrapper"},[_c('vs-navbar',{staticClass:"vx-navbar navbar-custom vx-custom-nav",class:_vm.classObj},[_c('vue-menutabs'),_c('vs-spacer')],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }